import { BookOpenCheckIcon, ClipboardCheckIcon, CloudLightningIcon, SirenIcon, ThermometerIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'El Niño Site Readiness Checklist',
    description: 'A practical pre-season checklist to review drainage, water, power, access, people and emergency readiness at your site.',
    icon: ClipboardCheckIcon,
  },
  {
    number: '2',
    title: 'Extreme Weather Emergency Response Quick Guide',
    description: 'A fast reference for what to do before, during and after floods, storms and heatwaves.',
    icon: SirenIcon,
  },
  {
    number: '3',
    title: 'Climate Risk & ENSO Technical Glossary',
    description: 'The key terms of ENSO, forecasting and climate risk explained in clear, practical language.',
    icon: BookOpenCheckIcon,
  },
  {
    number: '4',
    title: 'Heat Stress Field Card for Workers',
    description: 'A field card to recognize heat illness symptoms and apply prevention and first-response measures.',
    icon: ThermometerIcon,
  },
  {
    number: '5',
    title: 'Early Warning Indicators Cheat Sheet',
    description: 'The signals and indicators to watch so you can act before the weather becomes an emergency.',
    icon: CloudLightningIcon,
  },
];
